import React from 'react'
import {Cookies} from "react-cookie-consent";
import {useTranslation} from 'react-i18next';
import {useDispatch, useSelector} from 'react-redux';
import {closeDialog} from '../../slices/dialog';
import {storeChangeSidebar} from '../../slices/management';
import {selectSelectedCompany, selectSelectedRm} from '../../slices/selected';
import {Button} from "react-bootstrap";

export const StudentRmTutorial = () => {
    const dispatch = useDispatch();
    const rm = useSelector(selectSelectedRm);
    const company = useSelector(selectSelectedCompany);
    const {t} = useTranslation();

    const onClose = () => {
        Cookies.set("rmTutorialDone", true, {expires: 1000});
        dispatch(closeDialog());
    }

    return (
        <div className="studentRmTutorial">
            {/*old version of this dialog*/}
            {/*<p>*/}
            {/*    {t("student_rmTutorial_p11") + " "}<strong>{rm?.name}</strong>*/}
            {/*</p>*/}
            {/*<p>*/}
            {/*    {t("student_rmTutorial_p12") + " "}<strong>{company?.name}</strong><br />*/}
            {/*</p>*/}
            {/*<p>*/}
            {/*    {t("student_rmTutorial_p13")}*/}
            {/*</p>*/}
            {/*<p>*/}
            {/*    {t("student_rmTutorial_p2")}*/}
            {/*</p>*/}
            <h1>
                {t("student_rmTutorial_p_new_title")}
            </h1>
            <p className={"my-5"}>
                {t("student_rmTutorial_p_new")}
            </p>
            <Button className={"w-100 oval-borders"} size={"lg"}
                    onClick={onClose}>{t("student_rmTutorial_btn_new")}</Button>
        </div>
    )
}